import { render } from "./DoctorsActivity.vue?vue&type=template&id=6de5b340&scoped=true"
import script from "./DoctorsActivity.vue?vue&type=script&lang=js"
export * from "./DoctorsActivity.vue?vue&type=script&lang=js"

import "./DoctorsActivity.vue?vue&type=style&index=0&id=6de5b340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de5b340"]])

export default __exports__